module.exports = __webpack_public_path__ + "img/link3.138a8c82.png";